import { render, staticRenderFns } from "./PlayerLastPlaces.vue?vue&type=template&id=c73636a4&"
import script from "./PlayerLastPlaces.vue?vue&type=script&lang=js&"
export * from "./PlayerLastPlaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports